// src/helpers/devolucion.js

// (Opcional) set de tipos por compatibilidad con código viejo
export const DEV_TYPES = new Set(["ajuste", "ajuste_devolucion", "devolucion_pago"]);

export function n(x) {
  const v = Number(x);
  return Number.isFinite(v) ? v : 0;
}
export function r2(x) {
  return Math.round((x + Number.EPSILON) * 100) / 100;
}

/**
 * Desglosa pagos:
 * - abonadoPositivo: suma de pagos > 0
 * - devueltoHistorico: SOLO devoluciones al cliente (tipo 'devolucion_pago')
 * - ajustesDevolucion: comisiones/ajustes de devolución (tipo 'ajuste' o 'ajuste_devolucion')
 * - otrosNegativos: otros negativos (condonaciones, etc.)
 */
export function desglosarPagos(deuda) {
  const pagos = Array.isArray(deuda?.pagos) ? deuda.pagos : [];
  let abonadoPositivo = 0;
  let devueltoCliente = 0;
  let ajustesDev = 0;
  let otrosNeg = 0;

  for (const p of pagos) {
    const cant = n(p?.cantidad);
    const tipo = String(p?.tipo || "").toLowerCase();

    if (cant > 0) {
      abonadoPositivo += cant;
    } else if (cant < 0) {
      if (tipo === "devolucion_pago") devueltoCliente += Math.abs(cant);
      else if (tipo === "ajuste_devolucion" || tipo === "ajuste") ajustesDev += Math.abs(cant);
      else otrosNeg += Math.abs(cant);
    }
  }

  return {
    abonadoPositivo: r2(abonadoPositivo),
    devueltoHistorico: r2(devueltoCliente),   // ← SOLO lo que ya se devolvió al cliente
    ajustesDevolucion: r2(ajustesDev),        // ← comisiones/gastos por devolución
    otrosNegativos: r2(otrosNeg),
  };
}

/**
 * Total abonado para devolución = pagos positivos + (enganche si NO está registrado como pago)
 */
export function abonadoTotalParaDevolucion(deuda) {
  const { abonadoPositivo } = desglosarPagos(deuda);
  const engancheCampo = n(deuda?.enganche);
  const engancheYaEnPagos = Array.isArray(deuda?.pagos)
    ? deuda.pagos.some(p => String(p?.tipo || "").toLowerCase() === "enganche" && n(p?.cantidad) > 0)
    : false;

  const abonado = abonadoPositivo + (engancheYaEnPagos ? 0 : engancheCampo);
  return r2(Math.max(abonado, 0));
}

/**
 * Comisión por cancelación: toma primero campo explícito, si no, usa los ajustes negativos de devolución.
 */
export function obtenerComisionCancelacion(deuda) {
  const campo = n(deuda?.comisionCancelacion) || n(deuda?.devolucion?.comision);
  if (campo > 0) return r2(campo);

  // fallback: si no hay campo explícito, usa lo registrado como ajustes de devolución
  const { ajustesDevolucion } = desglosarPagos(deuda);
  return r2(ajustesDevolucion);
}

/**
 * Base inicial de devolución (monto total a reembolsar) = abonadoTotal - comisión
 */
export function calcularBaseInicialDevolucion(deuda) {
  const abonado = abonadoTotalParaDevolucion(deuda);
  const comision = obtenerComisionCancelacion(deuda);
  return r2(Math.max(abonado - comision, 0));
}

/**
 * Pendiente por devolver HOY = base inicial - ya devuelto al cliente
 */
export function calcularPendienteDevolver(deuda) {
  const base = calcularBaseInicialDevolucion(deuda);
  const { devueltoHistorico } = desglosarPagos(deuda); // solo 'devolucion_pago'
  return r2(Math.max(base - devueltoHistorico, 0));
}

// Alias por compatibilidad con código previo
export function maximoReembolsableHoy(deuda) {
  return calcularPendienteDevolver(deuda);
}
